module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "orders-list-wrapper"
  }, [_c('div', {
    staticClass: "header-wrapper"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.shopInfo.name) + " / 订单管理")])]), _vm._v(" "), _c('div', {
    staticClass: "manager-wrapper"
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.orderStatus),
      callback: function($$v) {
        _vm.orderStatus = $$v
      },
      expression: "orderStatus"
    }
  }, _vm._l((_vm.statusOptions), function(statusOption, index) {
    return _c('el-radio-button', {
      key: index,
      attrs: {
        "label": statusOption.label
      }
    }, [_vm._v(_vm._s(statusOption.text))])
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-wrapper"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.orderList,
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._l((props.row.purchase_records), function(record) {
          return _c('el-row', {
            key: record.id,
            staticClass: "order-details-cell"
          }, [_c('el-col', {
            attrs: {
              "span": 3
            }
          }, [_c('img', {
            staticClass: "product-img",
            attrs: {
              "src": _vm._f("ossurl")(record.product.imgs[0])
            }
          })]), _vm._v(" "), _c('el-col', {
            attrs: {
              "span": 12
            }
          }, [_c('div', {
            staticClass: "product-title"
          }, [_vm._v(_vm._s(record.product.name))]), _vm._v(" "), _c('div', {
            staticClass: "product-description"
          }, [_vm._v(_vm._s(record.product.description))]), _vm._v(" "), _c('div', {
            staticClass: "product-price"
          }, [_vm._v("$ " + _vm._s(record.product.price))])]), _vm._v(" "), _c('el-col', {
            attrs: {
              "span": 9
            }
          }, [_c('div', {
            staticClass: "product-amount"
          }, [_vm._v("x" + _vm._s(record.amount))]), _vm._v(" "), _c('el-button', {
            attrs: {
              "size": "small",
              "type": "danger"
            },
            on: {
              "click": function($event) {
                return _vm.viewOrderComments(props.row.id, record.product.id)
              }
            }
          }, [_vm._v("查看评论")])], 1)], 1)
        }), _vm._v(" "), _c('div', {
          staticClass: "order-details-footer"
        }, [_vm._v("运费：$" + _vm._s(props.row.transportation_cost))]), _vm._v(" "), _c('div', {
          staticClass: "order-details-footer"
        }, [_vm._v("合计：$" + _vm._s(props.row.total_price) + " (" + _vm._s(_vm._f("shippingMethodFilter")(props.row.shipping_method)) + ")")]), _vm._v(" "), _c('div', {
          staticClass: "order-details-footer"
        }, [_vm._v("收款人姓名：" + _vm._s(props.row.receiver_name))]), _vm._v(" "), _c('div', {
          staticClass: "order-details-footer"
        }, [_vm._v("手机号：" + _vm._s(props.row.phone))]), _vm._v(" "), _c('div', {
          staticClass: "order-details-footer"
        }, [_vm._v("地址：" + _vm._s(props.row.address))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "serial_num",
      "label": "订单号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "receiver_name",
      "label": "收件人姓名"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "phone",
      "label": "手机号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "total_price",
      "label": "总价"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "status",
      "formatter": _vm.getStatus,
      "label": "状态"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "300",
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status === 1) ? _c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.cancelOrder(scope.row.id, scope.$index)
            }
          }
        }, [_vm._v("取消订单")]) : _vm._e(), _vm._v(" "), (scope.row.status === 1) ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.confirmOrder(scope.row.id, scope.$index)
            }
          }
        }, [_vm._v("确认收货")]) : _vm._e(), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.sendOrderMail(scope.row.id, scope.$index)
            }
          }
        }, [_vm._v("发送至邮箱")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "page-block"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": _vm.pageSize,
      "layout": "total, prev, pager, next, jumper",
      "total": _vm.totalCount
    },
    on: {
      "current-change": _vm.currentPageChanged,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "查看评论",
      "visible": _vm.showCommentDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.showCommentDialog = $event
      }
    }
  }, [_c('el-form', {
    model: {
      value: (_vm.commentForm),
      callback: function($$v) {
        _vm.commentForm = $$v
      },
      expression: "commentForm"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "商品打分"
    }
  }, [_c('el-rate', {
    attrs: {
      "disabled": ""
    },
    model: {
      value: (_vm.commentForm.rate),
      callback: function($$v) {
        _vm.$set(_vm.commentForm, "rate", $$v)
      },
      expression: "commentForm.rate"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "商品评价"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.commentForm.comment || "无") + "\n      ")])], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showCommentDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.showCommentDialog = false
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-615b09de","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/shop/order-list.vue
// module id = 800
// module chunks = 1